import React, { useMemo } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

interface IProps {
  children?: React.ReactNode;
}

export const DragAndDropProvider: React.FC<IProps> = ({ children }) => {
  // Create a stable backend instance to prevent re-initialization issues with Vite HMR
  const backend = useMemo(() => HTML5Backend, []);

  return <DndProvider backend={backend}>{children}</DndProvider>;
};
